// extracted by mini-css-extract-plugin
module.exports = {"carousel":"DailyCarousel_carousel__ySnIY"};